module.exports = [{"id":724,"alpha2":"es","alpha3":"esp","name":"España"},{"id":620,"alpha2":"pt","alpha3":"prt","name":"Portugal"}]


//////////////////
// WEBPACK FOOTER
// ./src/resources/countries.json
// module id = 780
// module chunks = 0